module.exports = __webpack_public_path__ + "static/media/montana.288d242d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/albums/montana.jpeg
// module id = 290
// module chunks = 0